module.exports = __webpack_public_path__ + "static/media/indicator-darkgreen-under15.a047b663.png";